import { ITableRowViewModel } from './tableRowViewModel';
import { FindingModel } from '../api/finding.model';
import { ViolationModel } from '../api/violations.model';
import { MenuAction } from '../menuAction.model';

export enum IssueItemType {
  Runtime = 'Runtime', // For findings
  Posture = 'Posture', // For violations
}

export interface IssueFindingsViolationsTableRowViewModel extends ITableRowViewModel {
  rowId: string;
  id: string;
  integrationId: string;
  type: IssueItemType;
  timestamp: string;
  platformIcon: string; // Icon path for separate icon column
  name: string; // finding.rule.displayName or violation.rule.displayName
  severity: string;
  user: string; // Actor name for findings, Created By for violations
  ruleTags: string; // Comma-separated rule tags string for Tag column type

  // Original data for side panel
  finding?: FindingModel;
  violation?: ViolationModel;

  // Table display
  clickable: boolean;
  menuActions: MenuAction[];
}
